import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '../../../model/user';
import { UserService } from '../../../service/user.service';
import { DomainService } from '../../../service/domain.service';
import { Provincia } from '../../../model/provincia';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-profilo',
  templateUrl: './profilo.component.html',
  styleUrls: ['./profilo.component.css']
})
export class ProfiloComponent implements OnInit {

    province: Array<Provincia> = new Array<Provincia>();
    user: User = new User();

    constructor(
        private adapter: DateAdapter<any>,
        private userSrv: UserService,
        private domainSrv: DomainService
    ) { }

    ngOnInit() {
        // this.loadUser();
        // this.adapter.setLocale('it');
        this.initComponent();
    }

     updateUser() {
        this.userSrv.updateUser(this.user)
            .pipe(first())
            .subscribe(
                data => {
                    this.user = data;
                },
                error => {
                    // this.error = error;
                    // this.loading = false;
                }
            );
    }

    private initComponent() {
        this.loadProvince(this, function callback(that, province: Array<Provincia>) {
            that.province = province;
            that.loadUser();
        });
    }

    private loadUser() {
        this.userSrv.getUser()
        .pipe(first())
            .subscribe(
                data => {
                    this.user = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadProvince(that: any, callback: (that: any, province: Array<Provincia>) => void) {
        this.domainSrv.loadProvince()
        .pipe(first())
            .subscribe(
                data => {
                    callback(that, data);
                    // this.province = data;
                },
                error => {
                    return;
                }
            );
    }

}
